import { ItemAlergeno, ItemAlergenoMap } from 'app/modulos/recurso/item/item';
import { Cardapio, CardapioItem } from './cardapio';

function normaliza(texto: string): string {
  return (texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

function itemCasaBusca(item: CardapioItem, busca: string): boolean {
  return !busca || normaliza(`${item.nome} ${item.descricao || ''}`).includes(busca);
}

// Item sem alergeno cadastrado passa: o filtro so esconde o que a loja declarou.
function itemEvitado(item: CardapioItem, alergenos: ItemAlergeno[]): boolean {
  return (item.alergenos || []).some((alergeno) => alergenos.includes(alergeno));
}

// Sem filtro, devolve o proprio cardapio. Com filtro, categoria que fica vazia sai.
export function cardapioFiltra(cardapio: Cardapio, busca: string, alergenos: ItemAlergeno[]): Cardapio {
  const termo = normaliza(busca);
  if (!cardapio?.categorias || (!termo && !alergenos?.length)) {
    return cardapio;
  }
  return {
    ...cardapio,
    categorias: cardapio.categorias
      .map((categoria) => ({
        ...categoria,
        itens: (categoria.itens || []).filter(
          (item) => itemCasaBusca(item, termo) && !itemEvitado(item, alergenos || []),
        ),
      }))
      .filter((categoria) => categoria.itens.length),
  };
}

export const CATEGORIA_DESTAQUES = 'Destaques';

// O destaque e marcado no item, e o mesmo item aparece em mais de uma categoria: sem o
// filtro por id ele entraria repetido no carrossel.
export function cardapioDestaques(cardapio: Cardapio): CardapioItem[] {
  const vistos = new Set<string>();
  const destaques: CardapioItem[] = [];
  (cardapio?.categorias || []).forEach((categoria) => {
    (categoria.itens || []).forEach((item) => {
      if (item.destaque && !vistos.has(item.id)) {
        vistos.add(item.id);
        destaques.push(item);
      }
    });
  });
  return destaques;
}

// A categoria "Destaques" do backend repete o carrossel, entao sai da lista.
export function cardapioSemDestaques(cardapio: Cardapio): Cardapio {
  if (!cardapio?.categorias) {
    return cardapio;
  }
  return {
    ...cardapio,
    categorias: cardapio.categorias.filter((categoria) => categoria.nome !== CATEGORIA_DESTAQUES),
  };
}

// Categoria sem item so ocupa espaco e manda o atalho do topo para uma secao vazia.
export function cardapioSemVazias(cardapio: Cardapio): Cardapio {
  if (!cardapio?.categorias) {
    return cardapio;
  }
  return {
    ...cardapio,
    categorias: cardapio.categorias.filter((categoria) => categoria.itens?.length),
  };
}

// Alergenos que aparecem em algum item do cardapio, sem repeticao e na ordem do mapa -
// e o que o perfil da loja mostra. So conta o que a loja cadastrou nos itens.
export function cardapioAlergenos(cardapio: Cardapio): ItemAlergeno[] {
  const presentes = new Set<ItemAlergeno>();
  (cardapio?.categorias || []).forEach((categoria) =>
    (categoria.itens || []).forEach((item) => (item.alergenos || []).forEach((alergeno) => presentes.add(alergeno))),
  );
  return Array.from(ItemAlergenoMap.keys()).filter((alergeno) => presentes.has(alergeno));
}

export function alergenosTexto(alergenos: ItemAlergeno[]): string {
  return (alergenos || [])
    .map((alergeno) => ItemAlergenoMap.get(alergeno))
    .filter(Boolean)
    .join(', ');
}
